const tenantCodePattern = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;
export function resolveGsbHost(hostname, options = {}) {
    const accountHost = options.accountHost ?? "account.localhost";
    const baseHost = options.baseHost ?? "localhost";
    const accountTenantCode = options.accountTenantCode?.trim() || undefined;
    if (hostname === accountHost) {
        return { surface: "account", tenantCode: accountTenantCode };
    }
    if (hostname === options.workspaceSelectorHost) {
        return { surface: "workspace-selector" };
    }
    if (hostname === baseHost)
        return { surface: "workspace-selector" };
    const suffix = `.${baseHost}`;
    if (hostname.endsWith(suffix)) {
        const tenantCode = hostname.slice(0, -suffix.length);
        if (tenantCodePattern.test(tenantCode)) {
            return { surface: "workspace", tenantCode };
        }
    }
    return { surface: "workspace-selector" };
}
//# sourceMappingURL=host.js.map